import { render, staticRenderFns } from "./DeleteBuildingLog.vue?vue&type=template&id=74dfb27a&lang=pug&"
import script from "./DeleteBuildingLog.vue?vue&type=script&lang=ts&"
export * from "./DeleteBuildingLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports